export const REQUEST_WHITE_LIST = 'REQUEST_WHITE_LIST';
export const SUCCESS_WHITE_LIST = 'SUCCESS_WHITE_LIST';
export const FAILURE_WHITE_LIST = 'FAILURE_WHITE_LIST';
export const REQUEST_WHITE_LIST_ITEM = 'REQUEST_WHITE_LIST_ITEM';
export const SUCCESS_WHITE_LIST_ITEM = 'SUCCESS_WHITE_LIST_ITEM';
export const FAILURE_WHITE_LIST_ITEM = 'FAILURE_WHITE_LIST_ITEM';
export const GET_WHITE_LIST_TOTAL = 'GET_WHITE_LIST_TOTAL';